import PropTypes from 'prop-types';
import React from 'react';
import {
  FDBigPicklistInput, FDBox,
  FDDialog, FDDialogTitle, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

const VIEW_ALL_FILTER_PLACEHOLDER_VALUE = 'all'; // we need this because fd picklist does not support an id being undefine

const MobileOwnerFilters = ({ handleChange, currentVal, ownerOptions }) => {
  const [filterDialogOpen, setFilterDialogOpen] = React.useState(false);
  const options = ownerOptions.map((option) => {
    return {
      id: option.attr('id'),
      prompt: option.attr('prompt'),
    };
  });

  const onChange = (value) => {
    if (value === VIEW_ALL_FILTER_PLACEHOLDER_VALUE) {
      handleChange(undefined);
      setFilterDialogOpen(false);
      return;
    }
    handleChange(value);
    setFilterDialogOpen(false);
  };

  return (
    <FDStack direction={'row'} spacing={1} {...dataAttrs('owner-filters')}>
      <FDSecondaryActionButton
        icon="filterList"
        onClick={() => setFilterDialogOpen(true)}
        size={'sm'}
        label={'Filter'}
      />
      <FDDialog
        open={filterDialogOpen}
        onClose={() => setFilterDialogOpen(false)}
        closeOnBackdropClick
        dialogWidth={'sm'}
      >
        <FDDialogTitle value="Filter by owner" />
        <FDBox padding={2}>
          <FDBigPicklistInput
            onChange={onChange}
            value={currentVal ?? VIEW_ALL_FILTER_PLACEHOLDER_VALUE}
            options={[
              {
                id: VIEW_ALL_FILTER_PLACEHOLDER_VALUE,
                prompt: 'View all',
              },
              ...options,
            ]}

          />
        </FDBox>
      </FDDialog>
    </FDStack>
  );
};

MobileOwnerFilters.defaultProps = {};

MobileOwnerFilters.propTypes = {
  handleChange: PropTypes.func.isRequired,
  currentVal: PropTypes.string.isRequired,
  ownerOptions: PropTypes.object.isRequired,
};

export { MobileOwnerFilters };
